import { render, staticRenderFns } from "./DeptPickerConfig.vue?vue&type=template&id=255b0f54&scoped=true"
import script from "./DeptPickerConfig.vue?vue&type=script&lang=js"
export * from "./DeptPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b0f54",
  null
  
)

export default component.exports